import React from 'react';
import { Star, BadgeCheck } from 'lucide-react';
import { testimonials, showroomDetails } from '../mockData';

const RiderCommunity = () => {
  return (
    <section id="community" className="community-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">The Rider Community</h2>
          <p className="section-subtitle">
            Real riders, real experiences, real protection
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-header">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="testimonial-avatar"
                />
                <div className="testimonial-info">
                  <div className="testimonial-name-row">
                    <h4 className="testimonial-name">{testimonial.name}</h4>
                    {testimonial.verified && (
                      <BadgeCheck size={18} className="verified-badge" />
                    )}
                  </div>
                  <p className="testimonial-role">{testimonial.role}</p>
                </div>
              </div>

              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>

              <p className="testimonial-text">"{testimonial.text}"</p>
            </div>
          ))}
        </div>

        <div className="google-reviews-cta">
          <p className="reviews-text">Rated 4.9/5 on Google Reviews</p>
          <button
            className="btn-secondary reviews-button"
            onClick={() => window.open(showroomDetails.mapUrl, '_blank', 'noopener,noreferrer')}
          >
            Read More Reviews
          </button>
        </div>
      </div>
    </section>
  );
};

export default RiderCommunity;
